import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { forAll } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { isLetter } from "../fable_modules/fable-library-js.4.24.0/Char.js";

/**
 * Validate whether a given string is a valid name. Allows all alpha characters, space and hyphen.
 */
export function isValidName(name) {
    if (!isNullOrWhiteSpace(name)) {
        return forAll((c) => {
            if (isLetter(c) ? true : (c === " ")) {
                return true;
            }
            else {
                return c === "-";
            }
        }, name.split(""));
    }
    else {
        return false;
    }
}

//# sourceMappingURL=Validators.jsx.map
